module.exports = new __parcel__URL__("vibe-2-mobile.0f6afcd3.json").toString();